import type { TErrorMessageKey } from './I18n.types.ts';

export const errorMessages = {
  'error.request.network':
    'We could not reach Cascade. Check your connection and try again.',
  'error.request.timeout': 'Cascade took too long to answer. Please try again.',
  'error.request.aborted': 'The request was cancelled.',
  'error.request.unreadableResponse':
    'Cascade answered in a way we could not read.',
  'error.socket.refused': 'Cascade refused the request.',
  'error.unexpected': 'An unexpected error occurred.',
  'error.server.badRequest': 'The request was not valid.',
  'error.server.unauthorized': 'Your session has ended. Please sign in again.',
  'error.server.forbidden': 'You do not have access to this.',
  'error.server.notFound': 'We could not find what you were looking for.',
  'error.server.conflict': 'This conflicts with a change made elsewhere.',
  'error.server.validation': 'Some of the information provided is not valid.',
  'error.server.rateLimited':
    'Too many requests. Please wait a moment and try again.',
  'error.server.legalRestriction':
    'This request cannot be processed for legal reasons.',
  'error.server.internal':
    'Cascade ran into a problem. Please try again later.',
  'error.auth.actionInProgress': 'Another sign-in action is still in progress.',
  'error.auth.missingEmail':
    'We could not find the email this link was sent to. Please request a new link.',
  'error.auth.unsupportedDomain': 'This email domain is not supported.',
  'error.auth.unsupportedProvider': 'This sign-in provider is not supported.',
} as const satisfies Record<TErrorMessageKey, string>;
